import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

// AWS Configuration
import { Amplify } from 'aws-amplify';


Amplify.configure({
  Auth: {
    Cognito: {
      userPoolId: environment.aws_exports.userPoolId,
      userPoolClientId: environment.aws_exports.userPoolWebClientId,
      identityPoolId: environment.aws_exports.identityPoolId,
      loginWith: {
        email: true,
      },
    },
  },
  API: {
    REST: {
      "adminApi": {
        "endpoint": environment.restApiUrl,
        "region": environment.aws_exports.region,
      }
    }
  }
});

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
